import { IconButton, Stack, Typography } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MAX_IMAGE_UPLOAD_PIXELS } from '../../../Account/Images/imageUploadConfig';
import Tooltip from '../../../Common/_components/Tooltip';
import GuidelinesPanel from './ImageLibraryGuidelinesPanel';

export default function ImageLibraryImageGuidelines() {
	const [t] = useTranslation('design-lab');
	const [fileTypeHelpOpened, setFileTypeHelpOpened] = useState(false);

	return <GuidelinesPanel spacing={1.25}>
		<Typography variant="h4">{t('Image guidelines')}</Typography>
		<Stack sx={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) max-content', columnGap: 2, rowGap: 1, alignItems: 'start' }}>
			<ClickAwayListener onClickAway={() => setFileTypeHelpOpened(false)}>
				<Stack direction="row" spacing={0.5} alignItems="center" sx={{ minWidth: 0 }}>
					<Typography variant="body2" color="text.secondary">{t('File type')}</Typography>
					<Tooltip
						title={t('Only single, non-animated images are supported.')}
						open={fileTypeHelpOpened}
						onOpen={() => setFileTypeHelpOpened(true)}
						onClose={() => setFileTypeHelpOpened(false)}
						placement="top"
						describeChild
						variant="multiline"
						enterTouchDelay={0}
						leaveTouchDelay={5000}
					>
						<IconButton
							aria-label={t('Image file requirements')}
							size="small"
							onClick={() => setFileTypeHelpOpened(true)}
							sx={{ p: 0.25, flexShrink: 0 }}
						>
							<HelpOutlineRoundedIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				</Stack>
			</ClickAwayListener>
			<Typography variant="body2" fontWeight={700} textAlign="right" sx={{ whiteSpace: 'pre' }}>
				{t('JPG, PNG, WebP,\nTIFF, BMP, or GIF')}
			</Typography>
			<Typography variant="body2" color="text.secondary">{t('Color profile')}</Typography>
			<Typography variant="body2" fontWeight={700} textAlign="right">{t('sRGB')}</Typography>
			<Typography variant="body2" color="text.secondary">{t('Max file size')}</Typography>
			<Typography variant="body2" fontWeight={700} textAlign="right">{t('100 MB')}</Typography>
			<Typography variant="body2" color="text.secondary">{t('Max image size')}</Typography>
			<Typography variant="body2" fontWeight={700} textAlign="right" sx={{ whiteSpace: 'pre' }}>
				{t('{{megapixels}} MP\n({{side}} x {{side}} px)', {
					megapixels: MAX_IMAGE_UPLOAD_PIXELS / 1_000_000,
					side: Math.floor(Math.sqrt(MAX_IMAGE_UPLOAD_PIXELS)),
				})}
			</Typography>
		</Stack>
	</GuidelinesPanel>
}

